"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.

function s4() {
  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
}

function uuid() {
  return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
}

exports.uuid = uuid;
var usedIDs = new Set();
/** Generate a unique ID in uuid format */

function uniqueID() {
  while (true) {
    var id = Math.random().toString(36).substr(2);

    if (!usedIDs.has(id)) {
      usedIDs.add(id);
      return id;
    }
  }
}

exports.uniqueID = uniqueID;
var pointer = {};

function markID(datum) {
  if (!datum) {
    return null;
  }

  try {
    var tum = JSON.parse(datum);

    if (tum instanceof Array) {
      tum = tum[0];
    }

    if (tum._TYPE == "axis" || tum._TYPE == "nested-chart") {
      return null;
    }

    var namespace = tum._TYPE || "base-mark-group";

    if (pointer[namespace] === undefined) {
      pointer[namespace] = Object.keys(pointer).length * 1000 + 1;
    }

    return "mark" + pointer[namespace]++;
  } catch (_a) {
    return datum;
  }
}

exports.markID = markID;

function resetMarkID() {
  pointer = {};
}

exports.resetMarkID = resetMarkID;
var hashIndex = 1;
var objectHashs = new WeakMap();

function objectHash(o) {
  if (objectHashs.has(o)) {
    return objectHashs.get(o);
  }

  var newHash = "<#".concat(hashIndex.toString(), ">");
  hashIndex += 1;
  objectHashs.set(o, newHash);
  return newHash;
}

exports.objectHash = objectHash;